export default __webpack_public_path__ + "static/media/EAST1070.34I-34193_-18438_0.653f7cf0.jpg";